// extracted by mini-css-extract-plugin
export default {"Tecleado":"main_Tecleado__pPgIl","typing":"main_typing__g3g4u","blink":"main_blink__zSQGt"};